module.exports = __webpack_public_path__ + "img/logo-black.6bca4939.png";